"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupRootPage = GroupRootPage;
exports.groupRootMetadata = groupRootMetadata;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("@kalkulacka-one/app");
const client_1 = require("@kalkulacka-one/app/client");
const navigation_1 = require("next/navigation");
const clock_1 = require("../clock.js");
const calculator_1 = require("../guards/calculator.js");
const load_decided_in_1 = require("./load-decided-in");
const load_group_calculators_1 = require("./load-group-calculators");
async function GroupRootPage({ endpoint, segments, locale, embedContext, routes, homepageHref, privacyHref, launcher }) {
    const groupKey = segments.second;
    if (!groupKey)
        (0, navigation_1.notFound)();
    const [group, election] = await Promise.all([(0, app_1.ifFound)((0, app_1.loadCalculatorGroup)({ endpoint, group: groupKey })), (0, app_1.ifFound)((0, app_1.loadElection)({ endpoint, group: groupKey }))]);
    if (!group?.election || !election) {
        await (0, calculator_1.calculatorGuard)({ endpoint, key: groupKey, prefixed: true });
        (0, navigation_1.redirect)((0, app_1.addLauncherParam)(routes.introduction(segments, locale), launcher));
    }
    const current = (0, clock_1.now)();
    const calculators = await (0, load_group_calculators_1.loadGroupCalculators)({ endpoint, group: groupKey, keys: group.calculators.map((item) => item.key) });
    const decidedIn = await (0, load_decided_in_1.loadDecidedIn)({ endpoint, group: groupKey, keys: Object.keys(calculators), election, now: current });
    const picker = (0, app_1.districtPickerViewModel)({
        group,
        election,
        buildHref: (key) => (0, app_1.addLauncherParam)(routes.base({ ...segments, third: key }, locale), routes.base(segments, locale)),
        calculators,
        decidedIn,
        now: current,
    });
    const heading = { title: election.shortTitle ?? election.title };
    return (0, jsx_runtime_1.jsx)(client_1.DistrictPickerPage, { embedContext: embedContext, picker: picker, heading: heading, backHref: routes.homepage(locale), homepageHref: homepageHref, privacyHref: privacyHref });
}
async function groupRootMetadata({ endpoint, segments, canonical }) {
    if (!segments.second)
        return {};
    const [group, election] = await Promise.all([(0, app_1.ifFound)((0, app_1.loadCalculatorGroup)({ endpoint, group: segments.second })), (0, app_1.ifFound)((0, app_1.loadElection)({ endpoint, group: segments.second }))]);
    if (!group || !election)
        return {};
    const title = election.title;
    const description = group.description ?? election.description;
    const url = canonical.base(segments);
    return {
        title,
        description,
        alternates: { canonical: url },
        openGraph: { title, description, url },
        twitter: { card: "summary", ...(process.env.X_HANDLE && { site: process.env.X_HANDLE }), title, description },
    };
}
